import React, { useState } from 'react'
import leftMenu from '../../Images/leftMenu.png'
import closeMenu from '../../Images/closeMenu.png'
import Banner from '../../Images/Banner.png'
import telephone from '../../Images/telephone.png'
import book from '../../Images/book.png'
import './Header.scss';
import Arrow from '../../Images/downArrow.png'
import { useLocation } from 'react-router-dom'

export default function Header({ CitiePhone, showMenu, setShowMenu, navigateTo, WebSitePages }) {
    const [header, setHeader] = useState(false)
    const location = useLocation()
    return (
        <div className="Header">
            <div className="HeaderTopComputer">
                <div className="HeaderTopComputerMain">
                    <div className="Header3">
                        <div className="Header1BoxHedaer">
                            <h1>We Offer</h1>
                            <h2>EMERGENCY <span>LOCKSMITH SERVICES</span></h2>
                        </div>
                    </div>
                    <div className="Header2" >
                        <div className="Header2Logo">
                            <img src={require(`../../Images/LOGO2.png`)} />
                        </div>
                    </div>
                    <div className="Header1">
                        <div className="Header1BoxHedaer">
                            <h1>Contact us 24/7 at</h1>
                            <a target='_blank' href={`tel:${CitiePhone}`}>TAP TO CALL<img src={telephone} /></a>
                        </div>
                    </div>
                </div>

                <div className="Header4">
                    <p>EMERGENCY LOCKOUT SERVICE</p>
                    <p>ALL EMERGENCY SERVICES</p>
                    <p>LOCK CHANGE / REKEY</p>
                    <p>REPAIR LOCKS</p>
                    <p>COMMERCIAL LOCKSMITH</p>
                    <p>CAR KEY SOLUTION</p>
                </div>
            </div>
        </div>
    )
}
